import React from "react";
import { toast } from "sonner";

type ToastContent =
  | string
  | number
  | bigint
  | boolean
  | React.ReactNode
  | Iterable<React.ReactNode>
  | (() => React.ReactNode)
  | null
  | undefined;

export const showSuccessToast = (message: ToastContent | Promise<ToastContent>) => {
  if (message instanceof Promise) {
    message.then((resolvedMessage) => {
      toast.success(resolvedMessage, {
        duration: 4000,
        style: {
          background: "#475569",
          color: "white",
          border: "none",
          borderRadius: "8px",
        },
      });
    }).catch(() => {
      toast.success("", {
        duration: 4000,
        style: {
          background: "#475569",
          color: "white",
          border: "none",
          borderRadius: "8px",
        },
      });
    });
  } else {
    toast.success(message, {
      duration: 4000,
      style: {
        background: "#475569",
        color: "white",
        border: "none",
        borderRadius: "8px",
      },
    });
  }
};

export const showInfoToast = (message: ToastContent) =>
  toast.info(message, {
    duration: 3000,
    style: {
      background: "#64748b",
      color: "white",
      border: "none",
      borderRadius: "8px",
    },
  });

export const showErrorToast = (message: string) =>
  toast.error(message, {
    duration: 4000,
    style: {
      background: "#dc2626",
      color: "white",
      border: "none",
      borderRadius: "8px",
    },
  });
